/*!

=========================================================
* BootstrapVue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import vSelect from 'vue-select';
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
import router from './routes/router';

Vue.use(DashboardPlugin);
Vue.component('v-select', vSelect);
Vue.use(Toaster, { timeout: 10000 });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
});
